import { routing } from 'routing';

/* object explanation
  path - path on which the breadcrumb react, .* for any i.e. pipeline name
  name - name which should be displayed, for dynamic names - it will be concat to param value
  dynamic - is the name of breadcrumb dynamic
  index - index of value in url which will be concat, index of split by "/"
  search - default search param, should be set up if page use search, to avoid duplicating urls in browser history
  hash - default hash, should be set up if page use hashes, to avoid duplicating urls in browser history
  label - replace the name used for the link generation with the given literal
*/
export const allBreadcrumbs = [
  {
    path: `/${routing.statuses.name}`,
    name: "Statuses",
    icon: "StatusesIcon"
  },
  {
    path: `/${routing.aiTools.name}`,
    name: "AI Tools"
  },
  {
    path: `/${routing.aiTools.name}/${routing.aiTools.routing.aiTransformer.name}`,
    name: "AI Transformer Constructor"
  },
  {
    path: `/${routing.aiTools.name}/${routing.aiTools.routing.aiParser.name}`,
    name: "AI Parser Constructor"
  },
  {
    path: `/${routing.aiTools.name}/${routing.aiTools.routing.aiSummarizer.name}`,
    name: "AI Summarizer Constructor"
  },
  {
    path: `/${routing.dataLake.name}`,
    name: "Data lake",
    search: "?query=",
    hash: `#${routing.dataLake.routing.groups.name}`,
    icon: "LakeIcon"
  },
  {
    path: `/${routing.dataLake.name}/${routing.dataLake.routing.groups.name}/.*`,
    name: "",
    dynamic: true,
    index: 3,
    search: "?query="
  },
  {
    // Links to Review/<fileType>/<group>, which the Datalake routes redirect to the group page.
    path: `/${routing.dataLake.name}/${routing.dataLake.routing.review.name}/.*/.*`,
    name: "",
    dynamic: true,
    index: 4,
    search: "?query="
  },
  {
    path: `/${routing.dataLake.name}/${routing.dataLake.routing.review.name}/.*/.*/.*`,
    name: "Review: ",
    dynamic: true,
    index: 5
  },
  {
    path: `/${routing.dataStorage.name}`,
    name: "Data preps",
    search: "?query=",
  },
  {
    path: `/${routing.dataStorage.name}/${routing.dataStorage.routing.creator.name}/.*/.*/.*`,
    name: "",
    dynamic: true,
    search: "?query=",
    index: 4,
    hash: `#${routing.dataStorage.routing.creator.hashes.table}`
  },
  {
    path: `/${routing.dataStorage.name}/${routing.dataStorage.routing.creator.name}/New`,
    name: "Add Data prep",
    exact: true,
    search: "?query=",
    hash: `#${routing.dataStorage.routing.creator.hashes.table}`
  },
  {
    path: `/${routing.dataScience.name}`,
    name: "Pipelines",
    search: "?query=",
    hash: `#${routing.dataScience.routing.list.hashes.pipelines}`
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.task.name}/${routing.dataScience.routing.task.routing.creator.name}/.*`,
    name: "",
    dynamic: true,
    index: 4,
    label: "Task editor"
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.task.name}/${routing.dataScience.routing.task.routing.versions.name}/.*`,
    name: "",
    dynamic: true,
    index: 4,
    label: "Pipeline Versions"
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.creator.name}/.*/.*/.*`,
    name: "",
    dynamic: true,
    index: 4
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.creator.name}/New`,
    name: "Add New Pipeline",
    exact: true,
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.list.routing.versions.name}/.*/.*`,
    name: "Versions",
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.dashboard.name}`,
    name: "Monitor",
    hash: `#Recent`
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.dashboard.name}/${routing.dataScience.routing.dashboard.routing.details.name}`,
    name: "Details"
  },
  {
    path: `/${routing.dataScience.name}/${routing.dataScience.routing.dashboard.name}/${routing.dataScience.routing.dashboard.routing.history.name}/.*/.*`,
    dynamic: true,
    name: "Last runs: ",
    index: 5
  },
  {
    path: `/${routing.trash.name}`,
    name: "Trash",
  },
  {
    path: `/${routing.myAccount.name}`,
    name: "My Account",
    hash: `#${routing.myAccount.hashes.settings}`
  },
  {
    path: `/${routing.myAccount.name}/${routing.myAccount.routing.databaseAccountSetup}`,
    name: "My Account",
  },
  {
    path: `/${routing.myAccount.name}/${routing.myAccount.routing.company.name}/.*`,
    name: "Company: ",
    dynamic: true,
    search: "?query=",
    index: 3
  },
  {
    path: `/${routing.myAccount.name}/${routing.myAccount.routing.company.name}/.*/${routing.myAccount.routing.user.name}/.*`,
    name: "User: ",
    dynamic: true,
    index: 5
  },
  {
    path: `/${routing.myAccount.name}/${routing.myAccount.routing.user.name}/.*`,
    name: "User: ",
    dynamic: true,
    index: 3
  },
  {
    path: `/${routing.myAccount.name}/${routing.myAccount.routing.role.name}/.*`,
    name: "Role: ",
    dynamic: true,
    index: 3
  },
  {
    path: `/${routing.insight.name}`,
    name: "Insights"
  },
  {
    path: `/${routing.insight.name}/.*`,
    name: "",
    dynamic: true,
    index: 2,
    color: "white-base"
  },
  {
    path: `/${routing.insight.name}/.*/.*`,
    name: "",
    dynamic: false,
    index: 3,
    color: "white-base"
  },
  {
    path: `/${routing.insight.name}/.*/.*/.*`,
    name: "",
    dynamic: false,
    index: 4,
    color: "white-base"
  },
  {
    path: `/${routing.insight.name}/.*/.*/.*/*`,
    name: "",
    dynamic: true,
    index: 5,
    color: "white-base"
  },
]